import { closeModal, openModal } from '@components/modals';
import { execOnLoad } from '@general/helpers';
import './mobile-menu.scss';
import breakpoints from 'breakpoints';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initMobileMenu = (context) => {
  const snippetContainer = context.classList.contains('.mobile-menu__container')
    ? context
    : context.closest('.mobile-menu__container');
  if (!snippetContainer) return;
  const menuButton = snippetContainer.querySelector('.mobile-menu__icon');
  const closeButton = snippetContainer.querySelector('.mobile-menu__close');
  const modal = snippetContainer.querySelector('.modal');
  if (!menuButton || !modal || !closeButton) return;

  const closeMenu = () => {
    snippetContainer.classList.remove('open');
    closeModal(modal);
    document.body.classList.remove('mobile-menu-open');
    if (document.body.classList.contains('headroom--top')) {
      document.body.classList.remove('opacize');
    }
    snippetContainer
      .querySelectorAll('.mobile-menu__second-level.open')
      .forEach((secondLevel) => secondLevel.classList.remove('open'));
  };

  const openMenu = () => {
    snippetContainer.classList.add('open');
    openModal(modal);
    document.body.classList.add('mobile-menu-open');
    document.body.classList.add('opacize');
  };

  menuButton.addEventListener('click', () => {
    if (!modal.classList.contains('open')) openMenu();
  });

  closeButton.addEventListener('click', () => {
    if (modal.classList.contains('open')) closeMenu();
  });

  const lgUp = window.matchMedia(`(min-width: ${breakpoints.lg})`);
  const handleNavigation = () => {
    if (lgUp.matches && snippetContainer.classList.contains('open'))
      closeMenu();
  };
  lgUp.addEventListener('change', handleNavigation);

  snippetContainer
    .querySelectorAll('.mobile-menu__second-level')
    .forEach((secondLevel) => {
      const firstLevel = secondLevel.closest('.mobile-menu__first-level');
      const close = secondLevel.querySelector('.mobile-menu__back');
      if (!firstLevel || !close) return;
      const opener = firstLevel.querySelector(
        '.mobile-menu__first-level-link > span',
      );
      opener.addEventListener('click', () => secondLevel.classList.add('open'));
      close.addEventListener('click', () =>
        secondLevel.classList.remove('open'),
      );
    });
};

execOnLoad(window.dAgency.initMobileMenu, '.mobile-menu__container');
